import { render, staticRenderFns } from "./HollowAreaTrack.vue?vue&type=template&id=8a310df8&"
import script from "./HollowAreaTrack.vue?vue&type=script&lang=js&"
export * from "./HollowAreaTrack.vue?vue&type=script&lang=js&"
import style0 from "./HollowAreaTrack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports